import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidationService } from 'src/app/services/validation.service';

  @Component({
    selector: 'last-works',
    templateUrl: './last-works.component.html'
  })
  export class LastWorksComponent implements OnInit {
    @Input() form: FormGroup = null;
    strDidntWork: string = "";
    lastWorkItems: FormArray;
    ddlFamily = [ {"KOD":"1", "TEUR":"אני"}, 
                {"KOD":"2", "TEUR":"אימי"},
                {"KOD":"3", "TEUR":"אבי"},
                {"KOD":"4", "TEUR":"בן/בת זוג"}];
    message = "";
    msgBoxTitle = "";

    constructor(
        private translate: TranslateService,
        private formBuilder: FormBuilder
    ) {
        this.strDidntWork ="לא עבד/תי";
        this.msgBoxTitle ="רשימת מקומות תעסוקה ב-5 שנים אחרונות בהם עבדת בחו\"ל";
    }

    ngOnInit(): void {
        this.form.addControl('lastWorkItems', this.formBuilder.array([ this.createWorkItem() ]));
        
        this.lastWorkItems = this.form.get('lastWorkItems') as FormArray;
    }

    public get f() {
        return this.form.controls;  
    }

    public get f2(): FormGroup[] {
        return this.lastWorkItems.controls as Array<FormGroup>;  
    }

    addWorkItem() {
        this.lastWorkItems.push (this.createWorkItem());
    }

    createWorkItem() {
        return this.formBuilder.group({
                family_relation : new FormControl('1', [Validators.required]),
                finish_date : new FormControl('', [ValidationService.DateRequired]),
                job_place : new FormControl('', [Validators.required, ValidationService.specialCharactesValidator]),
                didnt_work : new FormControl(false, [Validators.required])
              });
    }

    removeWorkItem(i) {
    this.lastWorkItems.removeAt(i);
    }
    
    checkDidntWork(i) {
        let frm = this.lastWorkItems.controls[i] as FormGroup;
        let ff = frm.controls;
        if (ff.didnt_work.value == true) {
            ff.job_place.disable();
            ff.job_place.setValue(this.strDidntWork);    
            ff.finish_date.disable();
            ff.finish_date.setValue("");
        }
        else {
            ff.job_place.setValue(""); 
            ff.job_place.enable();
            ff.finish_date.enable();
        }      
    }

    openJobListDetailsPopup() {
       this.message ="המידע הינו לצורך קביעת הזכאות במשרד העלייה והקליטה בלבד, ולא יעשה בו שימוש אחר כלשהו. <br><br> יש למלא את הפרטים עבור ממלא הטופס והוריו. במידה ובן/בת הזוג אינם חוזרים יש למלא את הפרטים עבורו/ה. <br><br> יש למלא מקום עבודה מלא ללא ראשי תיבות. "
    }
  }